import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { PromiseStatuses } from "../../../../utils"
import {NewNotProcessingService} from './dataService/service'
import { filtersDTO, NotProcessingResponseDTO } from "./dataService/dto"

interface NotificationProcessingState {
    onEdit: boolean
    GetAllProcessingRowsResponse?: NotProcessingResponseDTO
    getAllProcessingRowsStatus: PromiseStatuses
    filtersUp: filtersDTO
}

const initialState: NotificationProcessingState = {
    onEdit: false,
    getAllProcessingRowsStatus: 'idle',
    filtersUp: {
        page: 0,
        itemsPerPage: 0
    }
}

export const GetAllNotProcessingRows = createAsyncThunk(
    'Not/GetAllNotProcessingRows',
    async (filters: filtersDTO, thunkApi): Promise<NotProcessingResponseDTO> => {
        const NotProcessingService = NewNotProcessingService()
        return NotProcessingService.GetAllNotProcessing(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const IdentificationBoardProcessingNotification = createAsyncThunk(
    'Not/IdentificationBoardProcessingNotification',
    async (notId: string, thunkApi): Promise<void> => {
        const NotProcessingService = NewNotProcessingService()

        return NotProcessingService.IdentificationBoardProcessingNotification(notId).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)


const NotificationLivestockSlice = createSlice({
    name: 'notificationLivestock/slice',
    initialState,
    reducers: {
        setOnEdit: (state, action) => {
            state.onEdit = action.payload
        },
        resetGetAllStatus: (state) => {
            state.getAllProcessingRowsStatus = 'idle'
        },
        resetFilters: (state) => {
            state.filtersUp = {
                page: 0,
                itemsPerPage: 0
            }
        }
       
    },
    extraReducers(builder) {
        builder

            .addCase(GetAllNotProcessingRows.pending, (state) => {
                state.getAllProcessingRowsStatus = 'loading'
            })
            .addCase(GetAllNotProcessingRows.fulfilled, (state, action) => {
                state.getAllProcessingRowsStatus = 'successfully'
                state.GetAllProcessingRowsResponse = action.payload
            })
            .addCase(GetAllNotProcessingRows.rejected, (state, action) => {
                state.getAllProcessingRowsStatus = 'failed'
            })

    }
})

export const {
    setOnEdit,
    resetGetAllStatus
} = NotificationLivestockSlice.actions

export default NotificationLivestockSlice.reducer